import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  SeatData,
  SeatMappingName,
  PostEditData,
  SetRemoveList,
  seatbookingData,
  SeatCoordsData,
} from '../../Redux/action/seatAction';
import Select from 'react-select';
import { dataUser, logoutHandler } from '../Helpers/util';
import ImageMapper from 'react-image-mapper';
import { toast } from 'react-toastify';
import mixpanel from 'mixpanel-browser';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwCheckbox from '../Common/FormComponent/SwCheckbox';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import SwModal from '../Common/SwModal/SwModal';
import SwTable from '../Common/SwTable/SwTable';
import AntDTable from '../Common/AntDTable/AntDTable';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from 'dayjs';


var QRCode = require('qrcode.react');
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
var options = [];
var options2 = [];

class SeatTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkaall: false,
      setname: '',
      checkedData: [],
      removecheck: false,
      titleset: '',
      dataAdd: false,
      allSeatbookItems: [],
      itemsList2: [],
      listName2: [],

      flexi_seat_id: '',
      user_id: '',
      start_date: '',
      end_date: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      title: '',
      imgname: '',
      hoveredArea: [],
      apiCodinates: [],
      setIndex: 0,
      normCheck: false,
      removelist: false,
      popSet: false,
      getData: {
        name: 'my-map',
        areas: [],
      },
      company_id: UserObj.company_id,
      isFlage: true,
      checkbox: false,
      // dataSend:[],
      itemsList: [],
      listName: [],
      pgno: 1,
      ImgUrl:
        'https://smartworks-web-production.s3-ap-southeast-1.amazonaws.com/floor_plan_images/',
      setAll: '',
      qrUrls: '',
      seat: '',
      seatno: '',
      name: '',
      seat_type: '',
      seat_vis: '',
      loader: false,
      CoordsList: [],
      loadMapView: 'Load',
      loadBusinessId: 0,
      apiCalled: 0,
      paramObj: {},
      showEditSeatOffCanvas: false,
      showSeatBookingOffCanvas: false,
      showQrModal: false,
    };
  }

  handleClosePop = () => {
    this.setState({
      popSet: false,
    });
  };

  handleOpenEditSeat = () => {
    this.setState({
      showEditSeatOffCanvas: true,
    });
  };

  handleCloseEditSeat = () => {
    this.setState({
      showEditSeatOffCanvas: false,
    });
  };

  handleOpenSeatBooking = () => {
    this.setState({
      showSeatBookingOffCanvas: true,
    });
  };

  handleCloseSeatBooking = () => {
    this.setState({
      showSeatBookingOffCanvas: false,
    });
  };

  makeMap = (company_id, business_id, i) => {
    const coordsObj = this.props.CoordsList[0];
    const setall =
      coordsObj.image_path_new == null
        ? coordsObj.image_path
        : coordsObj.image_path_new;
    const setQurImg = this.state.ImgUrl + setall;
    this.setState({
      setAll: setQurImg,
      setIndex: i,
    });
    const setDatas = [];
    this.props.CoordsList.map((items, i) => {
      if (items.co_ordinate_new != null) {
        setDatas.push({
          name: i,
          status: items.status,
          imgname: items.ufname + ' ' + items.ulname,
          title: items.title,
          shape: 'rect',
          coords:
            items.co_ordinate_new != null
              ? items.co_ordinate_new.split`,`.map(x => +x)
              : [items.co_ordinate],
          // coords: [items.co_ordinate],
          preFillColor:
            items.status == 0
              ? '#00800061'
              : items.status == 1
                ? ' #ff0000b5'
                : '#fbff006b',
        });
      } else {
        setDatas.push({
          name: i,
          shape: 'rect',
          coords:
            items.co_ordinate != null
              ? items.co_ordinate.split`,`.map(x => +x)
              : [items.co_ordinate],
          // coords: [items.co_ordinate],
          preFillColor:
            items.status == 0
              ? '#00800061'
              : items.status == 1
                ? ' #ff0000b5'
                : '#fbff006b',
        });
      }
      // this.state.MAP.areas = setDatas
    });
    this.setState(
      {
        myImg: this.props.name,
        getData: {
          name: 'my-map',
          areas: setDatas,
        },
        popSet: true,
      },
      () => { },
    );
  };

  handleCoords = (company_id, business_id, i) => {
    const param = {
      company_id,
      business_id
    }
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatCoordsData(param);
    if (this.props.CoordsList.length !== 0 && this.props.CoordsList[0].business_id == business_id) {
      const coordsObj = this.props.CoordsList[0];
      const setall = coordsObj.image_path_new == null ? coordsObj.image_path : coordsObj.image_path_new;
      const setQurImg = this.state.ImgUrl + setall;
      this.setState({
        setAll: setQurImg,
        setIndex: i,
      });
      const setDatas = [];
      this.props.CoordsList.map((items, i) => {
        if (items.co_ordinate_new != null) {
          setDatas.push({
            name: i,
            status: items.status,
            imgname: items.ufname + ' ' + items.ulname,
            title: items.title,
            shape: 'rect',
            coords:
              items.co_ordinate_new != null
                ? items.co_ordinate_new.split`,`.map(x => +x)
                : [items.co_ordinate],
            // coords: [items.co_ordinate],
            preFillColor:
              items.status == 0
                ? '#00800061'
                : items.status == 1
                  ? ' #ff0000b5'
                  : '#fbff006b',
          });
        } else {
          setDatas.push({
            name: i,
            shape: 'rect',
            coords:
              items.co_ordinate != null
                ? items.co_ordinate.split`,`.map(x => +x)
                : [items.co_ordinate],
            // coords: [items.co_ordinate],
            preFillColor:
              items.status == 0
                ? '#00800061'
                : items.status == 1
                  ? ' #ff0000b5'
                  : '#fbff006b',
          });
        }

        // this.state.MAP.areas = setDatas
      });

      this.setState(
        {
          myImg: this.props.name,
          getData: {
            name: 'my-map',
            areas: setDatas,
          },
          popSet: true
        },
        () => { },
      );
    } else {
      // setTimeout(() => {
      //   this.handleCoords(company_id, business_id, i)
      // }, 1000);
      this.setState({
        loadMapView: 'Loading',
        loadBusinessId: business_id
      })

    }
  };



  editSeatfunst = (val, items, i) => {
    this.state.itemsList[i].name = i;
    this.state.itemsList[i].seat_start_time = val.target.value;
    setTimeout(() => {
      this.setState({
        ...this.state.itemsList,
      });
    }, 1000);
  };

  SetOnchangeTime = (val, items, i) => {
    this.state.checkedData[i].name = i;
    this.state.checkedData[i].start_date = val.target.value;
    setTimeout(() => {
      this.setState({
        ...this.state.checkedData,
      });
    }, 1000);
  };
  SetOnchangeTime1 = (val, items, i) => {
    this.state.checkedData[i].name = i;
    this.state.checkedData[i].end_date = val.target.value;
    setTimeout(() => {
      this.setState({
        ...this.state.checkedData,
      });
    }, 1000);
  };

  setBook(parm1, param2, set) {
    this.setState({
      allSeatbookItems: parm1,
      flexi_seat_id: param2,
      titleset: set,
    });
  }

  onKeyDown2 = e => {
    if (e.target.value.length == 3) {
      this.handleChange2(e.target.value);
    }
  };

  handleChange2 = (val = '', itmes = {}, i = 0) => {
    let parm = {
      company_id: this.state.company_id,
      name: val,
    };
    if (val.value) {
      this.state.checkedData[i].user_id = val.value;
    }
    this.setState({
      ...this.state.checkedData,
      setname: val,
    });
    if (!UserObj?.company_id) {
      logoutHandler()
    }

    this.props.SeatMappingName(parm);
  };

  onKeyDown = e => {
    const formData = new FormData();
    if (e.target.value.length >= 3) {
      this.handleChange(e.target.value);
    }
  };

  handleChange = (val = '', itmes = {}) => {
    let parm = {
      company_id: this.state.company_id,
      name: val,
    };
    itmes.user_id = val.value;
    if (val.value == '') {
      itmes.seat_type = '2';
      itmes.isFixed = false;
    } else {
      let nFName = '';
      let nLName = '';
      const nammee = val.label;
      if (nammee) {
        const nameArray = nammee.split(' ');
        if (nameArray.length > 0) {
          nFName = nameArray[0];
          nLName = nammee.replace(nFName, '').trim();
        }
      }
      itmes.seat_type = '1';
      itmes.isFixed = true;
      itmes.user_id = val.value;
      itmes.ufname = nFName;
      itmes.ulname = nLName;
    }
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatMappingName(parm);
    this.setState({
      ...this.state.itemsList,
    });
  };

  Seatbooking = e => {
    e.preventDefault();
    options = [];
    options2 = [];
    this.state.itemsList2.map(item => {
      item.value = '';
      item.label = '';
    });
    this.setState({
      checkedData: [],
    });
    this.state.checkedData.map(item => {
      item.setname = '';
    });
    var data = {
      ...this.state.checkedData,
    };
    var setParm = data;
    var pars = {
      data: setParm,
      spoc_id: UserObj.rec_id,
    };
    this.state.itemsList.map((ite, i) => {
      ite.chk = false;
    });
    this.setState({
      dataAdd: true,
      flexi_seat_id: '',
      user_id: '',
      name: '',
      setname: null,
    });
    this.props.seatbookingData(pars);

    // Close the offcanvas after submission
    this.handleCloseSeatBooking();
  };

  editSeatfunen = (val = '', items = {}) => {
    items.seat_end_time = val.target.value;
    this.setState({
      ...this.state.itemsList,
    });
  };

  editSeatType = (val, items, i) => {
    this.state.itemsList[i].name = i;
    this.state.itemsList[i].ufname = '';
    this.state.itemsList[i].ulname = '';
    this.state.itemsList[i].seat_type = val.target.value;
    setTimeout(() => {
      this.setState({
        ...this.state.itemsList,
      });
    }, 1000);
  };

  editVis = (val, items, i) => {
    this.state.itemsList[i].name = i;
    this.state.itemsList[i].seat_vis = val.target.value;
    setTimeout(() => {
      this.setState({
        ...this.state.itemsList,
      });
    }, 1000);
  };
  remov;
  eSet(val, items, i) {
    let data;

    data = this.state.itemsList.map(items => {
      items.chk = false;
    });

    this.setState({
      ...this.state,
      checkbox: !this.state.checkbox,
      normCheck: !this.state.normCheck,
    });

    let param = {
      rec_id: items.rec_id,
    };
    this.props.SetRemoveList(param);
    this.setState({
      removelist: true,
    });
  }

  removeNewrow(e, i) {
    this.state.itemsList.splice(i, 1);
    this.setState({
      ...this.state.itemsList,
    });
  }

  addNewrow(e, items, i) {
    let newItems = { ...items };
    newItems.addbtn = false;
    newItems.rec_id = '';
    newItems.user_id = '';
    this.state.itemsList.splice(i + 1, 0, newItems);
    this.setState({
      ...this.state.itemsList,
    });
  }

  SubmitEdit = e => {
    let checkEmpVal = false;
    let checkTitle = '';
    this.state.itemsList.map(items => {
      items.chk = false;
      if (items.ufname == '' && items.seat_type == 1) {
        checkEmpVal = true;
        checkTitle = items.title;
      }
    });
    if (checkEmpVal)
      return toast.error(`Please select Emp Name for ${checkTitle}`);

    this.state.checkaall = false;
    this.setState({
      isFlage: true,
    });
    e.preventDefault();
    var updatedData = JSON.stringify(this.state.itemsList);

    let parm = {
      data: updatedData,
    };
    this.props.PostEditData(parm);

    let data;

    data = this.state.itemsList.map(items => {
      items.chk = false;
    });

    this.setState({
      ...this.state,
      checkbox: !this.state.checkbox,
      normCheck: !this.state.normCheck,
    });

    // Close the offcanvas after submission
    this.handleCloseEditSeat();
  };

  downloadQR = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'QR.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  checkAllCheck(e) {
    let data;
    if (e.target.checked) {
      this.state.checkaall = true;
      data = this.state.itemsList.map(items => {
        items.chk = true;
      });
    } else {
      this.state.checkaall = false;
      data = this.state.itemsList.map(items => {
        items.chk = false;
      });
    }
    this.setState({
      ...this.state,
      checkbox: !this.state.checkbox,
      normCheck: !this.state.normCheck,
    });
  }

  handleCheck = (e, items) => {
    let searchIndex = this.state.checkedData.findIndex(
      res => res.rec_id == items.rec_id,
    );
    if (searchIndex != -1) {
      this.state.checkedData.splice(searchIndex, 1);
    } else {
      this.state.checkedData.push(items);
    }
    this.setState({});

    if (e.target.checked) {
      items.chk = true;
    } else {
      this.state.checkaall = false;
      items.chk = false;
    }
  };

  changeforward = () => {
    this.setState({
      setIndex: this.state.setIndex + 1,
      loader: true,
    });

    var itemIndex = this.state.itemsList[this.state.setIndex + 1];
    var singleId = itemIndex.qr_code;
    let parm = {
      setAll: singleId,
    };
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };
  changebackformward = () => {
    this.setState({
      setIndex: this.state.setIndex - 1,
      loader: true,
    });

    var itemIndex = this.state.itemsList[this.state.setIndex - 1];
    var singleId = itemIndex.qr_code;
    let parm = {
      setAll: singleId,
    };
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };

  qrCodeUrl = (qrUrl, setaNum) => {
    let setQr = qrUrl;
    this.setState({
      qrUrls: setQr,
      seat: setaNum,
    });
  };

  btnClick() {
    mixpanel.track("Seat Management", { PageName: 'Seat Management', UserEmail: UserObj.email, UserName: UserObj.fname + " " + UserObj.lname, UserId: UserObj.rec_id, CompanyId: UserObj.company_id, CompanyName: UserObj.company_name, Type: "Seat Management" })
  }

  componentDidMount() {
    // this.btnClick();
  }

  senAllData(data) {
    const forPopEdit = data;
  }

  componentWillReceiveProps(props) {
    if (
      this.state.dataAdd == true &&
      this.props.setredAllValue.SeatBookingResult.status == 200
    ) {
      this.setState({
        dataAdd: false,
        // chk = false
      });
      this.state.checkedData.map((its, i) => {
        its.start_date = '';
        its.end_date = '';
      });
      this.state.itemsList.map((ite, i) => {
        ite.chk = false;
      });
      // this.checkedData.chk=false;
      let param = {
        pgno: this.props.seatPg,
        row: this.props.seatRow,
        company_id: this.state.company_id,
      };
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      this.props.SeatData(param);
    }

    // if (props.seatReducer && props.seatReducer.data !== 0) {
    //   this.setState({
    //     apiCodinates:
    //       props.seatReducer &&
    //       props.seatReducer.data &&
    //       props.seatReducer.data.co_ordinates,
    //   });
    // }

    if (props.seatReducer && props.seatReducer.status == 200) {
      this.setState({
        itemsList:
          props.seatReducer &&
          props.seatReducer.data &&
          props.seatReducer.data.list,
      });
    }
    if (props.seatName != '') {
      props.seatName &&
        this.setState({
          listName: props.seatName,
          listName2: props.seatName,
        });
    }
    if (
      this.state.isFlage == true &&
      props.listEdit &&
      props.listEdit.status == 200
    ) {
      this.setState({
        isFlage: false,
      });
      let parms = {
        company_id: this.state.company_id,
        pgno: this.props.seatPg,
        row: this.props.seatRow,
      };
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      this.props.SeatData(parms);
    }

    if (
      this.state.removelist == true &&
      props.removeList &&
      props.removeList.status == 200
    ) {
      let parms = {
        company_id: this.state.company_id,
        pgno: this.props.seatPg,
        row: this.props.seatRow,
      };
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      this.props.SeatData(parms);

      this.setState({
        removelist: false,
      });
    }
    if (this.props.CoordsList.length !== 0) {
      this.setState({
        loadMapView: 'View',
        apiCalled: 0,
      });
      if (
        this.props.CoordsList[0].business_id == this.state.paramObj.business_id
      ) {
        this.makeMap(
          this.state.company_id,
          this.state.business_id,
          this.state.i,
        );
      }
      // this.makeMap(this.state.company_id,this.state.business_id,this.state.i);
    }
  }

  enterArea(area) {
    this.setState({ hoveredArea: area });
  }
  leaveArea(area) {
    this.setState({ hoveredArea: null });
  }
  getTipPosition(area) {
    if (area.center) {
      return { top: `${area.center[1]}px`, left: `${area.center[0]}px` };
    }
  }

  render() {
    const SeatManagement = this.state.userRole.find(
      element => element.service_id == '2',
    );
    const seatListData = this.props.seatReducer;
    //--seatno---///
    if (this.props.seatName && this.props.seatName.length !== 0) {
      options = [{ value: '', label: 'Select' }];

      this.props.seatName.map(items => {
        options.push({
          value: items.rec_id,
          label: items.fname + ' ' + items.lname,
        });
      });
    }
    if (this.props.seatName && this.props.seatName.length !== 0) {
      options2 = [{ value: '', label: 'Select' }];

      this.props.seatName.map(items => {
        options2.push({
          value: items.rec_id,
          label: items.fname + ' ' + items.lname,
        });
      });
    }

    const seatVisOptions = [
      { value: "1", label: "Active" },
      { value: "2", label: "Inactive" },
    ];
    const seatTypeOptions = [
      { value: "1", label: "Fixed" },
      { value: "2", label: "Flexi" },
    ];


    const timeOptions = [
      { value: "01:00:00", label: "1:00" },
      { value: "01:30:00", label: "1:30" },
      { value: "02:00:00", label: "2:00" },
      { value: "02:30:00", label: "2:30" },
      { value: "03:00:00", label: "3:00" },
      { value: "03:30:00", label: "3:30" },
      { value: "04:00:00", label: "4:00" },
      { value: "04:30:00", label: "4:30" },
      { value: "05:00:00", label: "5:00" },
      { value: "05:30:00", label: "5:30" },
      { value: "06:00:00", label: "6:00" },
      { value: "06:30:00", label: "6:30" },
      { value: "07:00:00", label: "7:00" },
      { value: "07:30:00", label: "7:30" },
      { value: "08:00:00", label: "8:00" },
      { value: "08:30:00", label: "8:30" },
      { value: "09:00:00", label: "9:00" },
      { value: "09:30:00", label: "9:30" },
      { value: "10:00:00", label: "10:00" },
      { value: "10:30:00", label: "10:30" },
      { value: "11:00:00", label: "11:00" },
      { value: "11:30:00", label: "11:30" },
      { value: "12:00:00", label: "12:00" },
      { value: "12:30:00", label: "12:30" },
      { value: "13:00:00", label: "13:00" },
      { value: "13:30:00", label: "13:30" },
      { value: "14:00:00", label: "14:00" },
      { value: "14:30:00", label: "14:30" },
      { value: "15:00:00", label: "15:00" },
      { value: "15:30:00", label: "15:30" },
      { value: "16:00:00", label: "16:00" },
      { value: "16:30:00", label: "16:30" },
      { value: "17:00:00", label: "17:00" },
      { value: "17:30:00", label: "17:30" },
      { value: "18:00:00", label: "18:00" },
      { value: "18:30:00", label: "18:30" },
      { value: "19:00:00", label: "19:00" },
      { value: "19:30:00", label: "19:30" },
      { value: "20:00:00", label: "20:00" },
      { value: "20:30:00", label: "20:30" },
      { value: "21:00:00", label: "21:00" },
      { value: "21:30:00", label: "21:30" },
      { value: "22:00:00", label: "22:00" },
      { value: "22:30:00", label: "22:30" },
      { value: "23:00:00", label: "23:00" },
      { value: "23:30:00", label: "23:30" },
      { value: "24:00:00", label: "24:00" }
    ];



    return (
      <>
        <SwOffCanvas
          show={this.state.showSeatBookingOffCanvas}
          onClose={this.handleCloseSeatBooking}
          title="Seat Booking"
          placement="end"
          size="lg"
          backdrop="static"
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton
                variant="dark-outline"
                type="button"
                onClick={this.handleCloseSeatBooking}
                className="ml10"
              >
                Cancel
              </SwButton>
              <SwButton
                onClick={this.Seatbooking}
                variant="primary"
                className="ml10"
              >
                Update
              </SwButton>
            </div>
          }
        >
          <div className="addmemberformBody">
            {this.state.checkedData.length > 0 ? (
              this.state.checkedData.map((items, i) => (
                <div className="row" key={i}>
                  <div className="col-md-1 col-xl-1 col-lg-1">
                    <div className="titletest">{items.title}</div>
                  </div>
                  <div className="col-md-3 col-xl-3 col-lg-3">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel'>Employee</label>
                      <SwSelect
                        id='MSBEmployee'
                        onChange={e => this.handleChange(e, items)}
                        options={options2}
                        onKeyDown={this.onKeyDown}
                        menuPlacement="auto"
                        value={
                          items.ufname == '' || items.ufname == null
                            ? 'Select'
                            : {
                              label: items.ufname + ' ' + items.ulname,
                              value: items.user_id,
                            }
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-4 col-lg-4">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel'>Start Date</label>
                      <AntDDatePicker
                        type="single"
                        name="start_date"
                        value={items.start_date ? dayjs(items.start_date) : null}
                        allowClear={false}
                        disabledDate={(current) =>
                          current && current < dayjs().startOf("day")
                        }
                        onChange={(date) =>
                          this.SetOnchangeTime(
                            {
                              target: {
                                name: "start_date",
                                value: date ? date.format("YYYY-MM-DD") : "",
                              },
                            },
                            items,
                            i
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-4 col-lg-4">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel'>End Date</label>
                      <AntDDatePicker
                        type="single"
                        name="end_date"
                        value={items.end_date ? dayjs(items.end_date) : null}
                        disabled={!items.start_date}
                        allowClear={false}
                        disabledDate={(current) =>
                          current &&
                          (
                            current < dayjs(items.start_date) ||
                            current < dayjs().startOf("day")
                          )
                        }
                        onChange={(date) =>
                          this.SetOnchangeTime1(
                            {
                              target: {
                                name: "end_date",
                                value: date ? date.format("YYYY-MM-DD") : "",
                              },
                            },
                            items,
                            i
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p
                style={{
                  fontSize: '14px',
                  color: 'red',
                  textAlign: 'center',
                }}
              >
                Please Select Seat first
              </p>
            )}
          </div>
        </SwOffCanvas>


        {/* Floor View */}
        {this.state.popSet ? (
          <div className="showPop">
            <span className="closePop" onClick={this.handleClosePop}>
              <i class="bi bi-x-circle-fill"></i>
            </span>

            {this.state.itemsList.image_path_new &&
              this.state.itemsList.image_path == null ? (
              // <div className="presenter">
              //        <img src="img/demoClient.jpg" style={{'width':'100%'}} />
              // </div>

              <div className="presenter">
                <img src="img/demoClient.jpg" style={{ width: '100%' }} />
              </div>
            ) : (
              <div className="presenter">
                <ImageMapper
                  src={this.state.setAll}
                  map={this.state.getData}
                  width={1500}
                  onMouseEnter={area => this.enterArea(area)}
                  onMouseLeave={area => this.leaveArea(area)}
                />

                {this.state.hoveredArea && this.state.hoveredArea.status != 0 && (
                  <span
                    className="settips"
                    style={{ ...this.getTipPosition(this.state.hoveredArea) }}
                  >
                    <p className="setviewName">
                      {' '}
                      {this.state.hoveredArea.imgname}
                    </p>
                    <p className="setviewName">
                      {' '}
                      {this.state.hoveredArea.title}
                    </p>
                  </span>
                )}
              </div>
            )}
          </div>
        ) : null}

        <SwOffCanvas
          show={this.state.showEditSeatOffCanvas}
          onClose={this.handleCloseEditSeat}
          title="Edit Seat"
          placement="end"
          size="xl"
          backdrop="static"
          footer={
            <>
              <div className='pull-left'>
                <p className='SwTextDark fw-700'><b>Note:</b> Each slots should be 4 hours only.</p>
              </div>
              <div className="OffCanvasFooter_Btns">
                <SwButton
                  variant="dark-outline"
                  type="button"
                  onClick={this.handleCloseEditSeat}
                  className="ml10"
                >
                  Cancel
                </SwButton>
                <SwButton
                  onClick={this.SubmitEdit}
                  variant="primary"
                  className="ml10"
                >
                  Update
                </SwButton>
              </div>
            </>
          }
        >
          <SwTable
            className="SwTable-compact"
            columns={[
              {
                key: 'title',
                label: 'Seat No.',
                render: (row) => row.title
              },
              {
                key: 'seat_start_time',
                label: 'Booking Start Time',
                render: (row) => {
                  const rowIndex = this.state.itemsList.findIndex(item => item === row);
                  return (
                    <SwSelect
                      options={timeOptions}
                      value={timeOptions.find(
                        opt => opt.value === row.seat_start_time
                      )}
                      onChange={(selectedOption) =>
                        this.editSeatfunst(
                          {
                            target: {
                              name: "seat_start_time",
                              value: selectedOption ? selectedOption.value : ""
                            }
                          },
                          row,
                          rowIndex
                        )
                      }
                      placeholder="Select Start Time"
                      isClearable={false}
                    />
                  );
                }
              },
              {
                key: 'seat_end_time',
                label: 'Booking End Time',
                render: (row) => {
                  const rowIndex = this.state.itemsList.findIndex(item => item === row);
                  return (
                    <SwSelect
                      options={timeOptions}
                      value={timeOptions.find(
                        opt => opt.value === row.seat_end_time
                      )}
                      onChange={(selectedOption) =>
                        this.editSeatfunen(
                          {
                            target: {
                              name: "seat_end_time",
                              value: selectedOption ? selectedOption.value : ""
                            }
                          },
                          row,
                          rowIndex
                        )
                      }
                      placeholder="Select End Time"
                      isClearable={false}
                    />
                  );
                }
              },
              {
                key: 'seat_vis',
                label: 'Seat Status',
                render: (row) => {
                  const rowIndex = this.state.itemsList.findIndex(item => item === row);
                  return (
                    <SwSelect
                      id='SB'
                      options={seatVisOptions}
                      isClearable={false}
                      value={seatVisOptions.find(
                        opt => opt.value === String(row.seat_vis)
                      )}
                      onChange={(selectedOption) => {
                        this.editVis(
                          {
                            target: {
                              name: "seat_vis",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          },
                          row,
                          rowIndex
                        );
                      }}
                    />
                  );
                }
              },
              {
                key: 'employee_name',
                label: 'Employee Name',
                render: (row) => {
                  return (
                    <SwSelect
                      id='SBEditSeatEmployeName'
                      onChange={e => this.handleChange(e, row)}
                      options={options}
                      onKeyDown={this.onKeyDown}
                      menuPlacement="auto"
                      placeholder='Select'
                      value={
                        row.ufname == '' || row.ufname == null
                          ? 'Select'
                          : {
                            label: row.ufname + ' ' + row.ulname,
                            value: row.userid,
                          }
                      }
                    />
                  );
                }
              },
              {
                key: 'seat_type',
                label: 'Seat Type',
                render: (row) => {
                  const rowIndex = this.state.itemsList.findIndex(item => item === row);
                  return (
                    <SwSelect
                      options={seatTypeOptions}
                      isClearable={false}
                      isDisabled={row.isFixed}
                      value={seatTypeOptions.find(
                        opt => opt.value === String(row.seat_type)
                      )}
                      onChange={(selectedOption) => {
                        this.editSeatType(
                          {
                            target: {
                              name: "seat_type",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          },
                          row,
                          rowIndex
                        );
                      }}
                    />
                  );
                }
              },
              {
                key: 'actions',
                label: 'Add New',
                render: (row) => {
                  const rowIndex = this.state.itemsList.findIndex(item => item === row);
                  return (
                    <>
                      {row.plus_sign === 1 ? (
                        row.addbtn !== false ? (
                          <SwButton
                            variant="dark"
                            size="sm"
                            onClick={e => this.addNewrow(e, row, rowIndex)}
                          >
                            Add New Slot
                          </SwButton>
                        ) : (
                          <SwButton
                            variant="danger-outline"
                            size="sm"
                            onClick={e => this.removeNewrow(e, rowIndex)}
                          >
                            Remove
                          </SwButton>
                        )
                      ) : (
                        <SwButton
                          variant="danger-outline"
                          size="sm"
                          onClick={e => this.removeNewrow(e, rowIndex)}
                        >
                          Remove
                        </SwButton>
                      )}
                    </>
                  );
                }
              }
            ]}
            data={this.state.itemsList !== 0 && this.state.itemsList ? this.state.itemsList : []}
            pagination={false}
            loading={false}
          />

        </SwOffCanvas>

        <SwModal
          show={this.state.showQrModal}
          onClose={() => this.setState({ showQrModal: false })}
          className='sw-small-modal ExpandedWidth'
          footer={
            <div className="d-flex justify-content-center align-items-center gap-3">
              <SwButton
                variant="dark-outline"
                size='sm'
                onClick={() => this.downloadQR()}
              >
                Download QR
              </SwButton>
              <SwButton variant="primary" size='sm'>
                Print QR
              </SwButton>
            </div>
          }
        >
          <SwButton variant="" className='btn-close btn-close-custom' onClick={() => this.setState({ showQrModal: false })} ></SwButton>

          <h3 className='SwModalSubHeading ms-3'>Print Qr Code</h3>


          <div className="d-flex align-items-center gap-3">

            <div>
              <QRCode
                id="123456"
                value={this.state.qrUrls}
                size={150}
                level={'H'}
                includeMargin={true}
              />
            </div>

            <div>
              Seat Number : <strong>{this.state.seat}</strong>
            </div>

          </div>

        </SwModal>

        <div className="custome modal right fade" id="myModal3" data-backdrop="static">
          <div className="modal-dialog custome">
            <div className="modal-content custome">
              <div className="formTitle">
                Office Layout-Seat View
                <button
                  type="button"
                  className="relateDox close"
                  data-dismiss="modal"
                >
                  x
                </button>
              </div>

              <div className="modal-body custome pyful">
                {/* <div className="presenter">
                          <div className="not">
                              <ImageMapper src={this.state.setAll} map={MAP} width={713}                                  
                                onClick={area => this.clicked(area)}
                              />                                 
                          </div>
                      </div> */}

                <br />
                <br />
                <br />
              </div>
              <div className="addmemberFooter">
                <div className="pull-right">
                  <button
                    className="btn btn-outline-dark solCancel"
                    type="button"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                  {/* <button className="btn btn-success addDetails ml10">
                    Download
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>



        {(() => {
          const hasWriteAccess = SeatManagement && SeatManagement.role_for_write == '1';

          const columns = [
            ...(hasWriteAccess
              ? [
                {
                  title: (
                    <div className='d-flex align-item-center '>
                      <SwCheckbox
                        id="select-all"
                        name="selectAll"
                        label=""
                        checked={this.state.normCheck}
                        onChange={e => this.checkAllCheck(e)}
                      />
                      {(SeatManagement && SeatManagement.role_for_write == '1') && (
                        <SwButton
                          onClick={() => {
                            this.senAllData(seatListData.data.list);
                            this.handleOpenEditSeat();
                          }}
                          size="sm"
                          variant='dark'
                          disabled={!this.state.checkbox}
                        >
                          Edit
                        </SwButton>

                      )}
                    </div>

                  ),
                  key: 'select',
                  noWrap: true,
                  render: (_, items) => {
                    return items.seat_type != 1 && items.seat_vis == 1 ? (
                      <SwCheckbox
                        id={`seat-radio-${items.rec_id}`}
                        name="seatSelection"
                        checked={items.chk}
                        onChange={e => this.handleCheck(e, items)}
                      />
                    ) : (
                      <SwCheckbox
                        id={`seat-radio-disabled-${items.rec_id}`}
                        name="seatSelection"
                        checked={items.chk}
                        disabled={true}
                        className="disabledcheck"
                        onChange={e => this.handleCheck(e, items)}
                      />
                    );
                  },
                },
              ]
              : [
                {
                  title: '#',
                  key: 'serial',
                  noWrap: true,
                  render: (_, __, index) => index + 1,
                },
              ]),
            {
              title: 'Seat Number',
              dataIndex: 'title',
              key: 'title',
              noWrap: true,
            },
            {
              title: 'Seat Type',
              dataIndex: 'seat_type',
              key: 'seat_type',
              noWrap: true,
              render: (seatType) =>
                seatType == 1 ? (
                  <div className="SwTextDanger">Fixed</div>
                ) : (
                  <div className="SwTextSuccess">Flexi</div>
                ),
            },
            {
              title: 'Employee Name',
              key: 'employee_name',
              noWrap: true,
              render: (_, items) =>
                items.ufname == null
                  ? 'N/A'
                  : items.ufname + ' ' + items.ulname,
            },
            {
              title: 'Location',
              key: 'location',
              noWrap: true,
              render: (_, items) =>
                `${items.floor_name}, ${items.location_name}`,
            },
            {
              title: 'Seat Status',
              dataIndex: 'status',
              key: 'status',
              noWrap: true,
              render: (status) =>
                status == 0 ? (
                  <div className="SwTextSuccess">Vacant</div>
                ) : status == 1 || status == 2 ? (
                  <div className="SwTextSuccess">Occupied</div>
                ) : (
                  ''
                ),
            },
            {
              title: 'Seat Visibility',
              dataIndex: 'seat_vis',
              key: 'seat_vis',
              noWrap: true,
              render: (seatVis) =>
                seatVis == 1 ? (
                  <div className="SwTextSuccess">Active</div>
                ) : seatVis == 2 ? (
                  <div className="SwTextSuccess">Inactive</div>
                ) : (
                  ''
                ),
            },
            {
              title: 'Seat Plan',
              key: 'seat_plan',
              noWrap: true,
              align:"center",
              render: (_, items) => (
                <a
                  className="SwLinkInfo HoverUnderline"
                  onClick={() =>
                    this.handleCoords(
                      UserObj.company_id,
                      items.business_id,
                      this.state.itemsList.indexOf(items),
                    )
                  }
                >
                  View
                </a>
              ),
            },
            {
              title: 'Get QR',
              key: 'get_qr',
              align: "center",
              noWrap: true,
              render: (_, items) => (
                <a
                  type="button"
                  className="SwLinkSecondary"
                  role='button'
                  onClick={() => {
                    this.qrCodeUrl(items.qr_code, items.title);
                    this.setState({ showQrModal: true });
                  }}
                >
                  <i class="bi bi-qr-code"></i>
                </a>
              ),
            },
            ...(hasWriteAccess
              ? [
                {
                  title: 'Booking',
                  key: 'booking',
                  minWidth:150,
                  noWrap: true,
                  render: (_, items) => (
                    <SwButton
                      disabled={this.state.checkaall}
                      onClick={() => {
                        this.setBook(
                          seatListData.data.list,
                          items.rec_id,
                          items.title,
                        );
                        this.handleOpenSeatBooking();
                      }}
                      variant='dark-outline'
                      size='sm'
                      icon={<i class="bi bi-plus-circle"></i>}
                    >
                      Booking
                    </SwButton>
                  ),
                },
              ]
              : []),
          ];

          return (
            <AntDTable
              columns={columns}
              dataSource={this.state.itemsList && this.state.itemsList.length > 0 ? this.state.itemsList : []}
              rowKey="rec_id"
              loading={false}
              pagination
              currentPage={this.props.seatPg}
              pageSize={parseInt(this.props.seatRow)}
              totalRecords={seatListData?.data?.rows || 0}
              onPageChange={(page, pageSize) => {
                if (this.props.onPageChange) {
                  this.props.onPageChange(page, pageSize);
                }
              }}
              size="small"
            />
          );
        })()}
      </>
    );
  }
}

const mapStateToProps = state => ({
  seatReducer: state.seatReducer.SeatList,
  seatName: state.seatReducer.SeatMapData,
  CoordsList: state.seatReducer.CoordsList,
  listEdit: state.seatReducer.RoomResponseEdit,
  removeList: state.seatReducer.Roomlistremove,
  seatReducer: state.seatReducer.SeatList,
  setredAllValue: state.seatReducer,
});

const mapActionsToProps = {
  SeatData,
  SeatMappingName,
  PostEditData,
  seatbookingData,
  SetRemoveList,
  SeatCoordsData,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SeatTable);
